import dataTools from '../tools/data'
import errorMixin from './logHandler.js'
import fieldsDescription from '../tools/fieldsDescription.json'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  mixins: [errorMixin],
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  methods: {
    getUnitLabelFromPath(fieldPath, context) {
      const fieldType = dataTools.getFieldTypeFromPath(fieldPath, context, null)
      return dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
    },
    getLabelFromPath(fieldPath, context) {
      return dataTools.getFieldLabelFromPath(fieldPath, context)
    },
    getGuiValueFromPath(value, fieldPath, context) {
      const fieldType = dataTools.getFieldTypeFromPath(fieldPath, context, null)
      return dataTools.convertSi2gui(fieldType, value)
    },

    getDisplayValueFromPath(value, fieldPath, context) {
      const fieldType = dataTools.getFieldTypeFromPath(fieldPath, context, null)
      if (fieldType === 'enum') {
        return dataTools.convertEnum2Display(context, fieldPath, value)
      } else {
        return dataTools.convertSi2Display(fieldType, value)
      }
    },
    getLabelWithUnitFromPath(fieldPath, context) {
      const unitLabel = this.getUnitLabelFromPath(fieldPath, context)
      const valueLabel = this.getLabelFromPath(fieldPath, context)
      return unitLabel ? `${valueLabel}${unitLabel}` : `${valueLabel}`
    },
    getHeaderObjectFromPath(fieldPath, context) {
      return {
        text: this.getLabelFromPath(fieldPath, context),
        value: fieldPath[fieldPath.length - 1]
      }
    },
    getDescriptionHeaderObjectFromPath(fieldPath, context) {
      return {
        text: this.getLabelFromPathFieldDescription(fieldPath, context),
        value: fieldPath[fieldPath.length - 1]
      }
    },
    isValidResultPath(path) {
      return (
        Array.isArray(path) &&
        path.length > 0 &&
        path[0] !== '' &&
        !(path.length === 1 && path[0] === 'subMissions') &&
        !(path.length === 2 && path[0] === 'subMissions')
      )
    },
    isCustomFieldPath(path) {
      return path[0] === 'scriptInputs' || path[0] === 'scriptOutputs'
    },
    getDescriptionFieldFromPath(pathOrigin, context) {
      const path = [...pathOrigin]
      if (typeof path[0] === 'string' && path[0].startsWith('linkMargin')) {
        path[0] = 'linkMargin'
      } else if (
        typeof path[0] === 'string' &&
        path[0].startsWith('linkElevation')
      ) {
        path[0] = 'linkElevation'
      }

      let startIndex = path[0] === 'subMissions' ? 2 : 0
      let field = fieldsDescription[context].properties[path[startIndex]]
      const currentPath = new Array()
      currentPath.push(field)
      startIndex = startIndex + 1
      for (let i = startIndex; i < path.length; i++) {
        // Handle list of values
        if (!this.isNumber(path[i])) {
          field = fieldsDescription[field.type][path[i]]
        } else if (
          this.isNumber(path[i]) &&
          (field.type === 'vector' || field.type === 'matrix')
        ) {
          field =
            fieldsDescription[currentPath[i - 2].type][
              field.dimensions[path[i]]
            ]
        }
        currentPath.push(field)
      }
      return field
    },
    getInputTypeFromPathFieldDescription(fieldPath, context) {
      if (!this.isValidResultPath(fieldPath)) {
        return ''
      }
      if (this.isCustomFieldPath(fieldPath)) {
        let topBranch = fieldPath[0]
        let customFieldName = fieldPath[1]
        if (
          scriptConfig &&
          scriptConfig[topBranch] != null &&
          customFieldName != null
        ) {
          return scriptConfig[topBranch][customFieldName].type
        } else {
          return ''
        }
      }
      let field = this.getDescriptionFieldFromPath(fieldPath, context)
      if (field == null) {
        console.log(
          'getFieldTypeFromPathFieldDescription : Unknown result field ' +
            fieldPath +
            ' in ' +
            context
        )
        return ''
      }
      if (field.type != null) {
        return field.type
      }
      return ''
    },
    getLabelFromPathFieldDescription(fieldPath, context) {
      if (!this.isValidResultPath(fieldPath)) {
        return ''
      }
      if (this.isCustomFieldPath(fieldPath)) {
        if (fieldPath.length >= 2) {
          return fieldPath[1]
        } else {
          return ''
        }
      }

      let field = this.getDescriptionFieldFromPath(fieldPath, context)
      if (field == null) {
        console.log(
          'getFieldLabelFromPath : Unknown result field ' +
            fieldPath +
            ' in ' +
            context
        )
        return ''
      }
      return field.label
    },
    getUnitLabelFromPathFieldDescription(fieldPath, context) {
      const fieldType = this.getInputTypeFromPathFieldDescription(
        fieldPath,
        context
      )
      return dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
    },
    getDisplayValueFromPathFieldDescription(value, fieldPath, context) {
      const fieldType = this.getInputTypeFromPathFieldDescription(
        fieldPath,
        context
      )
      if (fieldType === 'enum') {
        return dataTools.convertEnum2Display(context, fieldPath, value)
      } else {
        return dataTools.convertSi2Display(fieldType, value)
      }
    },
    getLabelWithUnitFromPathFieldDescription(fieldPath, context) {
      const unitLabel = this.getUnitLabelFromPathFieldDescription(
        fieldPath,
        context
      )
      const valueLabel = this.getLabelFromPathFieldDescription(
        fieldPath,
        context
      )
      return unitLabel ? `${valueLabel}${unitLabel}` : `${valueLabel}`
    },

    turnBackDate(date, time, units) {
      return moment(date).subtract(time, units).toISOString()
    },

    advanceDate(date, time, units) {
      return moment(date).add(time, units).toISOString()
    },

    async getDataSatellite({
      name,
      color,
      tle,
      startDate,
      endDate,
      stepInSeconds,
      orbitLine,
      pointsPlanes,
      pointsLines
    }) {
      let positionsSatellite
      let velocitySatellite
      let datesSatellite
      let inputPos = {
        tle: tle,
        startDate: startDate,
        endDate: endDate,
        stepInSeconds: stepInSeconds
      }
      if (
        inputPos.tle != null &&
        inputPos.startDate != null &&
        inputPos.endDate != null &&
        inputPos.stepInSeconds != null
      ) {
        let self = this
        await this.$http
          .post('/physics/ephemeridesfromtle', inputPos)
          .then((response) => {
            positionsSatellite = response.data.positions
            datesSatellite = response.data.dates
            velocitySatellite = response.data.velocity
          })
          .catch((e) => {
            self.displayMessage(
              'Error in loading positions of satellite',
              e,
              'notification',
              'error'
            )
          })
      }

      return {
        name: name,
        color: color,
        positions: positionsSatellite,
        velocity: velocitySatellite,
        dates: datesSatellite,
        orbitLine: orbitLine,
        planes: pointsPlanes,
        lines: pointsLines
      }
    },

    async getDataTwoSatellites({
      firstName,
      secondName,
      firstColor,
      secondColor,
      firstTles,
      secondTles,
      startDate,
      endDate,
      firstOrbitLine,
      secondOrbitLine,
      firstPlanes,
      secondPlanes
    }) {
      let positionsFirstSat
      let positionsSecondSat
      let dates
      let relativeDistanceEphemerides
      let relativeDistanceT
      let relativeDistanceN
      let relativeDistanceW
      let relativeDistanceRequest = {
        firstTles: firstTles,
        secondTles: secondTles,
        initialPropagationDate: startDate,
        finalPropagationDate: endDate,
        extendedResultsEnabled: true,
        firstOrbitDefinitionType: 'TLE',
        secondOrbitDefinitionType: 'TLE'
      }
      if (
        relativeDistanceRequest.firstTles != null &&
        relativeDistanceRequest.secondTles != null &&
        relativeDistanceRequest.initialPropagationDate != null &&
        relativeDistanceRequest.finalPropagationDate != null
      ) {
        let self = this
        let validResult = true
        await this.$http
          .post('/physics/relativedistance', relativeDistanceRequest)
          .then((response) => {
            positionsFirstSat = response.data.referencePositions
            positionsSecondSat = response.data.otherObjectPositions
            dates = response.data.propagationDates
            relativeDistanceEphemerides =
              response.data.relativeDistanceEphemerides
            relativeDistanceT = response.data.relativeDistanceT
            relativeDistanceN = response.data.relativeDistanceN
            relativeDistanceW = response.data.relativeDistanceW
          })
          .catch((e) => {
            self.displayMessage(
              'Error in loading positions of satellite',
              e,
              'notification',
              'error'
            )
            validResult = false
          })

        if (!validResult) {
          return []
        } else {
          return [
            {
              name: firstName,
              color: firstColor,
              positions: positionsFirstSat,
              dates: dates,
              orbitLine: firstOrbitLine,
              planes: firstPlanes,
              lines: [
                {
                  pointName: secondName,
                  relativeDistanceEphemerides: relativeDistanceEphemerides,
                  relativeDistanceT: relativeDistanceT,
                  relativeDistanceN: relativeDistanceN,
                  relativeDistanceW: relativeDistanceW
                }
              ]
            },
            {
              name: secondName,
              color: secondColor,
              positions: positionsSecondSat,
              dates: dates,
              orbitLine: secondOrbitLine,
              planes: secondPlanes,
              lines: null
            }
          ]
        }
      } else {
        return []
      }
    },

    async getOrbitalElementsFromTles(tles) {
      let self = this
      let orbitalsElements
      await this.$http
        .post(
          '/users/' +
            this.currentUser.id +
            '/screeningcatalogueanalysisrequests/orbitalelementsfromtles',
          tles
        )
        .then((response) => (orbitalsElements = response.data))
        .catch((e) => {
          self.displayMessage(
            'Error while getting orbital elements.',
            e,
            'notification',
            'error'
          )
          return null
        })
      return orbitalsElements
    },

    async getOrbitalElementsFromMission(noradId, missionId) {
      let self = this
      const params = {}
      params.noradId = noradId
      params.missionId = missionId
      let orbitalsElements
      await this.$http
        .get(
          '/users/' +
            this.currentUser.id +
            '/screeningcatalogueanalysisrequests/orbitalelementsfrommission',
          { params }
        )
        .then((response) => (orbitalsElements = response.data))
        .catch((e) => {
          self.displayMessage(
            'Error while getting orbital elements.',
            e,
            'notification',
            'error'
          )
          return null
        })
      return orbitalsElements
    }
  }
}
